import loadable from '@loadable/component';

export default loadable(() => import(/* webpackChunkName: "size-guide-layout" */ './SizeGuide'));
